export * from './translate.pipe';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/pipes/index.ts